import React, {Component} from 'react';
import ConfirmationMessage from "../../components/confirmationMessage"
import MaintenanceAccountsView from "./MaintenanceAccountsView";
import {MaintenanceAccountsService} from "../../service/admin/maintenanceAccounts/MaintenanceAccountsService";
import {
    EDIT_ACCOUNT_ROUTE,
    INSERT_ACCOUNT_ROUTE,
    MAINTENANCE_ACCOUNTS_ROUTE
} from "../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import ContextMenu from "../../components/contextMenu";
import {replaceAccents} from "../../utils/formatters/Accent"
import {InstitutionService} from "../../service/maintenance/institution/InstitutionService";

export default class MaintenanceAccountsContainer extends Component {

    /**
     * Constructor de la clase MaintenanceAccountsContainer
     * en este se inicializan los valores iniciales de la clase.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);

        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }

        this.maintenanceAccountsService = new MaintenanceAccountsService();
        this.institutionService = new InstitutionService();

        this.getDataAccounts = this.getDataAccounts.bind(this);
        this.redirectAddAccount = this.redirectAddAccount.bind(this);
        this.redirectEditAccount = this.redirectEditAccount.bind(this);
        this.deleteAccount = this.deleteAccount.bind(this);
        this.maintAccountsOrderActionTemplate = this.maintAccountsOrderActionTemplate.bind(this);
        this.openConfirmationDelete = this.openConfirmationDelete.bind(this);
        this.loading = this.loading.bind(this);

        this.state = {
            dataMaintAccounts: this.getDataAccounts(),
            selectedAccount: '',
            deleteAccountValue: '',
            anchorEl: null,
            isLoading: true,
        };

    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    /**
     * Función que obtiene el valor de la lista de cuentas
     * haciendo la petición al service.
     * @returns {list} Lista obtenida de la petición.
     */
    getDataAccounts() {
        this.loading(true);
        return this.maintenanceAccountsService.getAccounts()
            .then(dataAccounts => {
                this.setState({
                    dataMaintAccounts: dataAccounts,
                });
                this.loading(false);
            });
    }

    /**
     * Función que guarda la opción de context menu que fue seleccionada
     * @param event
     */
    handleClick = event => {
        this.setState({anchorEl: event.currentTarget});
    };

    /**
     * Función que cierra el context menu cuando se seleccionó alguna
     * de las opciones desplegadas
     */
    handleClose = () => {
        this.setState({anchorEl: null});
    };

    /**
     * Función que contruye un template para la última columna de la tabla
     * donde se muestra un menú contextual con las opciones editar y eliminar.
     * @returns {html} Menú contextual (Editar, Eliminar)
     */
    maintAccountsOrderActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar ", action: this.redirectEditAccount},
            {label: "Eliminar", action: this.openConfirmationDelete}
        ];
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    /**
     * Función que abre el mensaje de confirmación para borrar un registro de la tabla.
     * Guarda el elemento a eliminar en una variable del estado.
     */
    openConfirmationDelete() {
        if (this.state.selectedAccount) {
            this.setState({deleteAccountValue: this.state.selectedAccount.cuenta})
            this.handleClose();
            if (this.confirmationRef) {
                this.confirmationRef.openConfirmationMessage()
            }
        }
    }

    /**
     * Función que redirecciona a la pantalla de agregar cuenta
     */
    redirectAddAccount() {
        let infoInstAux = {};
        if (this.state.dataMaintAccounts.length === 0){
            this.institutionService.getInstitution(localStorage.getItem('institutionId'))
                .then(resp => {
                    infoInstAux = resp.length === 0 ? {} : resp[0];
                    if (infoInstAux.idInst !== undefined && infoInstAux.idInst !== ''){
                        this.props.history.push({
                            pathname: INSERT_ACCOUNT_ROUTE,
                            state: {
                                returnPath: MAINTENANCE_ACCOUNTS_ROUTE,
                                idInst: infoInstAux.idInst,
                                folioInst: infoInstAux.folioInst,
                            },
                        });
                    }
                })
        }else {
            infoInstAux = this.state.dataMaintAccounts[0];
            this.props.history.push({
                pathname: INSERT_ACCOUNT_ROUTE,
                state: {
                    returnPath: MAINTENANCE_ACCOUNTS_ROUTE,
                    idInst: infoInstAux.idInst,
                    folioInst: infoInstAux.folioInst,
                },
            });
        }
    }


    /**
     * Función que redirecciona a la pantalla de Editar cuenta
     */
    redirectEditAccount() {
        this.props.history.push({
            pathname: EDIT_ACCOUNT_ROUTE,
            state: {
                returnPath: MAINTENANCE_ACCOUNTS_ROUTE,
                datosCuenta: this.state.selectedAccount,
            },
        });
    }

    /**
     * Función que maneja el cambio en el elemento seleccionado en la tabla.
     * @param event Contiene la información del objeto a eliminar
     */
    handleSelectAccount = (event) => {
        this.setState({
            selectedAccount: event.value,
        });
    };

    /**
     * Función que consume el MaintenanceAccountsService y elimina el
     * elemento seleccionado.
     */
    deleteAccount() {
        this.loading(true);
        this.maintenanceAccountsService.deleteAccount(this.state.deleteAccountValue)
            .then(resp => {
                if (resp.message === "Success") {
                    this.growl.show({
                        severity: 'success', summary: 'Éxito.',
                        detail: 'Se ha eliminado su solicitud con éxito.'
                    });
                    this.getDataAccounts();
                } else if (resp.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: replaceAccents(resp.error)
                    });
                }
                this.loading(false);
            });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Está seguro que desea eliminar el registro?"
                                            action={this.deleteAccount}/>;

        const {dataMaintAccounts, isLoading} = this.state;
        return (
            <MaintenanceAccountsView
                dataMaintAccounts={dataMaintAccounts}
                isLoading={isLoading}
                messagesGrowl={messagesGrowl}
                maintAccountsOrderActionTemplate={this.maintAccountsOrderActionTemplate}
                handleSelectAccount={this.handleSelectAccount}
                confirmationMsg={this.confMsg}
                getDataAccounts={this.getDataAccounts}
                redirectAddAccount={this.redirectAddAccount}
            />
        );
    }
}
